// @ts-nocheck
import React from "react";
import { Container, Linha, Aviso } from "./styles";

// "2026-08-28T00:00:00.000000Z" -> "28/08/2026" (só a parte da data, sem
// converter fuso: meia-noite UTC viraria o dia anterior no Brasil)
export const formatarData = (data) => {
  const [ano, mes, dia] = (data || "").slice(0, 10).split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : null;
};

// Soma meses a uma data "aaaa-mm-dd..." e devolve "dd/mm/aaaa".
// Dia que não existe no mês final vira o último dia (31/01 + 1 = 28/02).
export const somarMeses = (data, meses) => {
  const [ano, mes, dia] = (data || "").slice(0, 10).split("-").map(Number);
  if (!ano || !mes || !dia || !(Number(meses) > 0)) return null;
  const total = mes - 1 + Number(meses);
  const novoAno = ano + Math.floor(total / 12);
  const novoMes = (total % 12) + 1;
  const ultimoDia = new Date(Date.UTC(novoAno, novoMes, 0)).getUTCDate();
  const novoDia = Math.min(dia, ultimoDia);
  const dois = (n) => String(n).padStart(2, "0");
  return `${dois(novoDia)}/${dois(novoMes)}/${novoAno}`;
};

// Exigência mais recente entre as que a equipe liberou para o cliente
// ("Contato feito?" no Airtable).
export const exigenciaAtual = (requirements) => {
  const visiveis = (requirements || []).filter((r) => r?.show_to_client);
  if (!visiveis.length) return null;
  return visiveis.reduce((atual, r) =>
    String(r?.requirement_date || "") >= String(atual?.requirement_date || "")
      ? r
      : atual
  );
};

// O sync antigo gravava a descrição como booleano ("1"): nesse caso usa o título.
const descricao = (requirement) => {
  const texto = String(requirement?.reason_description ?? "").trim();
  return texto && texto !== "1" && texto !== "0"
    ? texto
    : requirement?.reason_title;
};

// Linha do tempo da exigência no card de acompanhamento (etapa "requirement").
export default function ExigenciaLinhaTempo({ process, requirement }) {
  const envio = formatarData(process?.post_date);
  const recebida = formatarData(requirement?.requirement_date);
  const resposta = formatarData(requirement?.answer_sent_at);
  const meses = Number(requirement?.expected_months);
  const retorno = somarMeses(requirement?.answer_sent_at, meses);

  return (
    <Container>
      {envio && (
        <Linha>
          <span className="ponto" />
          <div>
            <strong>Enviado para Portugal</strong>
            <p>{envio}</p>
          </div>
        </Linha>
      )}
      <Linha>
        <span className={resposta ? "ponto" : "ponto atual"} />
        <div>
          <strong>Exigência recebida</strong>
          <p>
            {[recebida, descricao(requirement)].filter(Boolean).join(" · ")}
          </p>
        </div>
      </Linha>
      {resposta && (
        <>
          <Linha>
            <span className="ponto" />
            <div>
              <strong>Resposta enviada</strong>
              <p>{resposta} · Enviamos o documento pedido.</p>
            </div>
          </Linha>
          <Linha>
            <span className="ponto atual" />
            <div>
              <strong>Aguardando a conservatória</strong>
              {retorno && (
                <p>
                  Previsão de retorno: até {meses}{" "}
                  {meses === 1 ? "mês" : "meses"} ({retorno}). Prazo informado
                  pela conservatória, atualizado em {resposta}.
                </p>
              )}
            </div>
          </Linha>
        </>
      )}
    </Container>
  );
}

// Aviso fixo da etapa de exigência.
export function ExigenciaNaoERecusa() {
  return (
    <Aviso>
      <strong>Exigência não é recusa.</strong>
      <p>
        É um pedido de complemento. Respondida, o processo volta à fila de
        análise do ponto em que parou.
      </p>
    </Aviso>
  );
}
